import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-full flex-col w-full bg-brand-black my-auto px-4 pt-14 z-50" }
const _hoisted_2 = { class: "flex text-white text-2xl font-medium text-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex relative" }
const _hoisted_6 = {
  key: 0,
  class: "flex w-full h-full absolute top-0 left-0 bg-brand-lime rounded-full z-20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-10 w-10 m-auto text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.5",
    width: "200",
    height: "200",
    rx: "100",
    fill: "#EBFF00"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M107.596 101.419C107.596 103.301 106.849 105.106 105.518 106.436C104.187 107.767 102.382 108.515 100.5 108.515C98.6178 108.515 96.8129 107.767 95.482 106.436C94.1512 105.106 93.4036 103.301 93.4036 101.419C93.4036 99.5365 94.1512 97.7316 95.482 96.4007C96.8129 95.0699 98.6178 94.3223 100.5 94.3223C102.382 94.3223 104.187 95.0699 105.518 96.4007C106.849 97.7316 107.596 99.5365 107.596 101.419Z",
    fill: "#1A1B22"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M83.4687 88.6458C81.9631 88.6458 80.5191 89.244 79.4544 90.3086C78.3897 91.3733 77.7916 92.8173 77.7916 94.3229V111.354C77.7916 112.86 78.3897 114.304 79.4544 115.368C80.5191 116.433 81.9631 117.031 83.4687 117.031H117.531C119.037 117.031 120.481 116.433 121.546 115.368C122.61 114.304 123.208 112.86 123.208 111.354V94.3229C123.208 92.8173 122.61 91.3733 121.546 90.3086C120.481 89.244 119.037 88.6458 117.531 88.6458H114.204C112.699 88.6455 111.255 88.0472 110.191 86.9824L107.84 84.6321C106.776 83.5674 105.332 82.9691 103.827 82.9688H97.1732C95.6677 82.9691 94.2239 83.5674 93.1595 84.6321L90.8092 86.9824C89.7448 88.0472 88.301 88.6455 86.7955 88.6458H83.4687ZM84.888 94.3229C84.5116 94.3229 84.1506 94.1734 83.8844 93.9072C83.6182 93.6411 83.4687 93.2801 83.4687 92.9036C83.4687 92.5272 83.6182 92.1662 83.8844 91.9001C84.1506 91.6339 84.5116 91.4844 84.888 91.4844C85.2644 91.4844 85.6254 91.6339 85.8916 91.9001C86.1577 92.1662 86.3073 92.5272 86.3073 92.9036C86.3073 93.2801 86.1577 93.6411 85.8916 93.9072C85.6254 94.1734 85.2644 94.3229 84.888 94.3229ZM110.435 101.419C110.435 104.054 109.388 106.581 107.525 108.444C105.662 110.307 103.135 111.354 100.5 111.354C97.8651 111.354 95.3381 110.307 93.4749 108.444C91.6118 106.581 90.5651 104.054 90.5651 101.419C90.5651 98.7844 91.6118 96.2574 93.4749 94.3942C95.3381 92.5311 97.8651 91.4844 100.5 91.4844C103.135 91.4844 105.662 92.5311 107.525 94.3942C109.388 96.2574 110.435 98.7844 110.435 101.419Z",
    fill: "#1A1B22"
  })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "mt-auto flex pb-20"
}
const _hoisted_11 = { class: "flex m-auto space-x-2.5" }
const _hoisted_12 = { class: "my-auto pt-0.5" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5 text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "mt-auto flex pb-20"
}
const _hoisted_18 = { class: "flex m-auto space-x-2.5" }
const _hoisted_19 = { class: "my-auto pt-0.5" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5 text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.choosePhoto && _ctx.choosePhoto(...args))),
              class: "flex flex-col w-full space-y-10 justify-center items-center relative"
            }, [
              _createElementVNode("div", _hoisted_2, [
                (!_ctx.avatar)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Add your profile picture"))
                  : _createCommentVNode("", true),
                (_ctx.avatar)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Looking good, " + _toDisplayString(_ctx.user.name) + "!", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.busy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  style: _normalizeStyle({
                  'background-image' : `url('data:image/jpeg;base64,${_ctx.avatar}')`
                }),
                  class: "w-full h-full bg-cover bg-center absolute top-0 left-0 rounded-full z-50"
                }, null, 4),
                _hoisted_9
              ])
            ]),
            (_ctx.avatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args))),
                    class: "mt-auto mx-auto w-full flex bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (!_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Continue"))
                          : _createCommentVNode("", true),
                        (_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.avatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args))),
                    class: "mt-auto mx-auto flex bg-brand-dark-gray rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (!_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Skip"))
                          : _createCommentVNode("", true),
                        (_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}